var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Video"}},[_c('youtube',{ref:"youtube",staticClass:"videoLoop",attrs:{"video-id":_vm.videoId,"player-vars":_vm.playerVars},on:{"playing":_vm.playing,"ready":_vm.ready,"ended":_vm.ended}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }